import React from 'react'
import PropTypes from 'prop-types'
import {Select, Spin} from 'antd';
import { Form } from '@ant-design/compatible';

const InputSelect = ({ mode, name, rules, initialValue, placeholder, form, loading, data, formItemStyle, disabled, onSearch, onChange }) => {
  const inputError = form.isFieldTouched(name) && form.getFieldError(name)
  return (
    <Form.Item
      style={formItemStyle}
      validateStatus={inputError ? 'error' : ''}
      help={inputError || ''}>
      {form.getFieldDecorator(name, {
        rules,
        initialValue: initialValue
      })(
        <Select
          mode={mode}
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
          //filterOption={false}
          disabled={disabled}
          placeholder={placeholder}
          onSearch={onSearch}
          onChange={onChange}
          notFoundContent={loading ? <Spin size="small" /> : null}
        >
          {data.map(d => (<Select.Option key={d.value}>{d.text}</Select.Option>))}
        </Select>
      )}
    </Form.Item>
  )
}

InputSelect.defaultProps = {
  data: [],
  mode: '',
  onSearch: () => {}
}

InputSelect.propTypes = {
  mode: PropTypes.string,
  form: PropTypes.object.isRequired,
  rules: PropTypes.array,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  formItemStyle: PropTypes.object,
  data: PropTypes.array,
  loading: PropTypes.bool,
  onSearch: PropTypes.func,
  onChange : PropTypes.func
}

export default InputSelect
